import { Spin } from "antd";

const SpinLoader = () => (
  <div style={{ width: "100%", textAlign: "center", marginTop: 50 }}>
    <Spin tip="Loading" size="small">
      Please wait while Loading Data...
    </Spin>
  </div>
);

export default SpinLoader;
